import Vue, { CreateElement } from 'vue'
import Component from 'vue-class-component'

import './index.sass'
import { Watch } from 'vue-property-decorator'

@Component({
  computed: {
    isSidebarVisible () {
      return this.$store.state.isSidebarVisible
    }
  }
})
export class BurgerIcon extends Vue {

  active: boolean = false
  isSidebarVisible: boolean

  updateState () {
    this.active = !this.active
    this.$store.dispatch('updateSidebarVisibility', this.active)
  }

  @Watch('isSidebarVisible')
  scrollUpOnRouteChange () {
    this.active = this.isSidebarVisible
  }

  render (h: CreateElement) {
    return (
      <svg
        ref={'burger-icon'}
        class={`burger-icon-root ${this.active && 'active'}`}
        viewBox='0 0 100 100'
        width='70%'
        onClick={() => { this.updateState() }}>
        <defs>
          <linearGradient id='burger-linear' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' stop-color='#4FACFE'/>
            <stop offset='50%' stop-color='#00F2FE'/>
            <stop offset='100%' stop-color='#4FACFE'/>
          </linearGradient>
        </defs>
        <path
          class={`line top`}
          stroke={'url(#burger-linear)'}
          d='m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40'
        />
        <path
          class={`line medium`}
          stroke={'#4FACFE'}
          d='m 30,50 h 40'
        />
        <path
          class={`line bottom`}
          stroke={'url(#burger-linear)'}
          d='m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40'
        />
      </svg>
    )
  }
}
